import Logo from 'assets/images/logo';
import BrowsingMode from './browsing-mode';
import { Container, SearchContainer } from './styles';

const Header = ({ showActions, showBrowseMode = true, children }) => (
  <Container>
    <SearchContainer>
      <Logo />
      {
        showActions && (
          <>
            {children}
          </>
        )
      }
    </SearchContainer>
    <>{showBrowseMode && <BrowsingMode />}</>
  </Container>
);

export default Header;
